import { RouteSegments } from '../routingClientAdmin.interface';

const base = `/${RouteSegments.Root.Config}/${RouteSegments.Config.ExternalReporting}`;

export const generateCoverageReportRoute = (reportId?: number | string) => {
  const pageUrl = `${base}/${RouteSegments.ExternalReporting.Reports}`;
  return reportId !== undefined ? `${pageUrl}/${reportId}` : pageUrl;
};

export const generateCoverageServerRoute = (id?: number | string) => {
  const pageUrl = `${base}/${RouteSegments.ExternalReporting.Servers}`;
  return id !== undefined ? `${pageUrl}/${id}` : pageUrl;
};
